import { Flex, Result } from 'antd';
import { AxiosError } from 'axios';
import { getErrorMessage } from '@shared/utils/errors/getErrorMessage';

const HTTP_STATUS_CODES_FOR_RESULT = ['403', '404', '500'];

export const ErrorMessage = ({ error }) => {
  let status = 'error';
  let title = 'Error';

  if (error instanceof AxiosError) {
    const statusCode = error.response?.status;

    if (statusCode) {
      title += ` ${statusCode}`;

      const statusCodeStr = String(statusCode)
      if (HTTP_STATUS_CODES_FOR_RESULT.includes(statusCodeStr)) {
        status = statusCodeStr;
      }
    }
  }

  const errorMessage = getErrorMessage(error);

  return (
    <Flex justify='center' align='center' style={{ height: '100%' }}>
      <Result status={status} title={title} subTitle={errorMessage} />
    </Flex>
  );
};